document.addEventListener('DOMContentLoaded', () => {

  let menuA = document.querySelectorAll('div.quick-access .menu .menu-item.quick-access__item a');


  let otherMenus = document.querySelector('.f20-top__acesso-wrap ul.quick-access');

  menuA.forEach((a) => {

    let newA = document.createElement('a');

    newA.setAttribute('href', a.getAttribute('href'));

    newA.setAttribute('target', '_blank');

    newA.innerHTML = a.innerHTML;


    otherMenus.appendChild(newA);
  });


  otherMenus.querySelectorAll('a').forEach((a) => {

    a.className = '';

    a.classList.add('quick-access__item', 'button', 'mediumGrey', 'outline', 'fluid');
  });
})
